import React, { FC } from 'react'

import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'

import { breakpoints } from 'components/designSystem/shared/breakpoints'
import { PercentSvg } from 'components/designSystem/svgr/PercentSvg'
import { ProfileFooterWaveSvg } from 'components/designSystem/svgr/ProfileFooterWaveSvg'
import { Typography } from 'components/designSystem/Typography/Typography'

export const ProfileFooter: FC<{ percent?: number }> = ({ percent }) => {
  return (
    <Parent data-name="compatibility">
      <ParentText>
        <Text fontSize={20} tag="p">
          <SwitchTextPercent percent={percent} />
        </Text>
        {Boolean(percent) && (
          <Percent
            fontSize={40}
            fontWeight={700}
            tag="p"
            data-name="compatibility-percent"
          >
            {percent} <PercentSvg />
          </Percent>
        )}
      </ParentText>
      <ProfileFooterWaveSvg />
    </Parent>
  )
}

const SwitchTextPercent: FC<{ percent?: number }> = ({ percent }) => {
  if (percent) {
    return (
      <FormattedMessage
        id="app.footer.match"
        defaultMessage="Похоже, {n} вы на одной волне"
        values={{ n: <br /> }}
      />
    )
  } else {
    return (
      <FormattedMessage
        id="app.footer.no.match"
        defaultMessage="Попробуйте узнать больше"
      />
    )
  }
}

const Parent = styled.div`
  display: grid;
  position: relative;
  overflow: hidden;

  @media screen and (min-width: ${breakpoints.mobile + 1}px) {
    margin: 0 calc(var(--spacing-24px) * -1);
  }
`

const ParentText = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
`

const Text = styled(Typography)`
  width: 205px;
  color: var(--foreground-muted);
  text-align: center;
`

const Percent = styled(Typography)`
  display: inline-grid;
  width: min-content;
  grid-template-columns: auto auto;
  align-items: center;
  color: var(--mamba-default);
`
